import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Conductores {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/conductor/create`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/conductor/update`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0, form) {
        const response = await Api.post({
            url: `${Backend}/conductor/list/${page}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/conductor/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
